import { Card, CardContent, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { ReactComponent as FilesIcon } from '../../assets/files.svg';
import { useEffect, useState } from "react";
import { Auth } from "aws-amplify";
import { clientConfig, SetS3Config } from "../../awsClientConfig";
import { GetLatestFormsByProfile } from "../../queries/GetLatestFormsByProfile";
import { Storage } from "aws-amplify";
import { fetchQuery } from "../../functions/misc";
import { GetProfileDocuments } from "../../queries/GetProfileDocuments";
import Skeleton from "react-loading-skeleton";
import { dayjs } from "../../lib/dayjs";

type Props = {
    profileData: any
}

const DocumentsList = ({profileData}: Props) => {
    const [documents, setDocuments] = useState<any>([]);
    const [loading, setLoading] = useState(true);
    const client = new clientConfig();

    const fetchProfileDocuments = async () => {
        setLoading(true);
        try{
            const profileDocuments = await fetchQuery({ ProfileId: profileData.Id, AccountId: profileData.AccountId }, GetProfileDocuments);
            setDocuments(profileDocuments);
        }catch(error){
            console.log(error);
        }finally{
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchProfileDocuments();
    },[profileData])
    
    return (
        <Card sx={{borderRadius: 1}}>
            <CardContent sx={{p:0, '&:last-child':{paddingBottom: 0}}}>
            <Typography variant="subtitle1" sx={{m:2, mb:3}}><FilesIcon className="me-2"/>{'Documents'}</Typography>
                <Table size="small" sx={{m:2, border: '1px solid  #DCDFE4', width: '95%'}}>
                    <TableHead>
                        <TableRow>
                            <TableCell align="center">
                                File Name
                            </TableCell>
                            <TableCell  align="center">
                                Uploaded Date
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                    {loading? <Skeleton />: <>
                        {documents && documents.length > 0 ?
                            <>
                                {documents.map((doc:any, index:number) => (
                                    <TableRow key={index}>
                                        <TableCell><a className="a-link-content-text" target="_blank" href={doc.PreSignedUrl}>{doc.FileName}</a></TableCell>
                                        <TableCell>{dayjs(doc.LastModified).format('MMM D, YYYY')}</TableCell>
                                    </TableRow>
                                ))}
                            </>

                        :
                            <TableRow>
                                <TableCell colSpan={2}>{'No documents found'}</TableCell>
                            </TableRow>
                        }
                    </>
                    }
                    </TableBody>
                </Table>
            </CardContent>
        </Card>
    );
}

export default DocumentsList;